import { render } from "./MyAccount.vue?vue&type=template&id=1eb149fa&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1eb149fa&scoped=true&lang=css&external"
import "./MyAccount.vue?vue&type=style&index=1&id=1eb149fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb149fa"]])

export default __exports__